import type { FaireProductEntity } from "../../entity_types/product";

export const p_p38cwjdqy2: FaireProductEntity = {
  token: "p_p38cwjdqy2",
  type: "product",
  name: "BOAT NECK LACE TRIM MINI DRESS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/8e282a7cf9f743fe3ccf78496901292d166f0555b917070ca691059e2c1d6052.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ec5c42038b237f73d3bd737c61fd1dc1df4a6c59edce7e1bde74abe02d17b1d4.jpeg",
    "https://cdn.faire.com/fastly/140f1bd4b73f3a1da36a075c440976c1ad08d50088d926c4fb701f36d4b3e109.jpeg",
    "https://cdn.faire.com/fastly/4630da2e017308fcdbaeef104b3f4a3291b6312b55da2b1047f1a9b4a8994a0e.jpeg",
    "https://cdn.faire.com/fastly/745f6d80ef9342a4aa0ba8390a9df5912330c29e57a9012f18204d600757417e.jpeg",
    "https://cdn.faire.com/fastly/905c95f400b79854632cb12685d526b4f757ee5cee0f0aa518cfe9dcd01687b7.jpeg",
  ],
  priceDollars: 204,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'10"\nBUST: 33B\nWAIST: 23.5"\nHIPS: 35"\n',
  tags: [],
  msrpDollars: 408,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:13.727Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
